export const loginFormContent = {
  SignIn: "Sign In",
  WelcomeBack: "Welcome back! Please enter your details",
  ForgotPassword: "Forgot Password?",
};
